import styled from "styled-components";
import { TooltipGlowDefaultBox } from "./tooltip-glow.default";


export const TooltipGlow777Box = styled(TooltipGlowDefaultBox)`
    display: none;
`;
